import styled from 'styled-components';

export const Container = styled.form`
  display: flex;
`;

export const Input = styled.input`
  width: 100%;
  height: 45px;
  font-size: 14px;
  padding: 15px 20px;
  color: var(--black-2);
  background: var(--white);
  border: 1px solid var(--gray-d);
  border-radius: 8px;
  margin-right: 10px;
  outline: 0;
  transition: 0.2s ease-in-out;

  :focus {
    border: 1px solid var(--primary);
  }
`;

export const Button = styled.button`
  min-width: 45px;
  height: 45px;
  background: var(--primary);
  color: var(--white-dark);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  outline: 0;
  transition: box-shadow 0.2s ease-in-out;

  :focus {
    box-shadow: 0 0 0px 3px rgba(0, 0, 0, 0.2);
  }
`;
